export default {
    "accountValidateMsg" : "Account must contain 6 - 30 characters, including letters, digits and symbols (\".\", \"_\", \"@\"). The first character must be digit or letter.",
    "storeSuccess" : "Recharge Success",
    "editAccountTips" : "Please enter a valid account name",
    "editPwdTips" : "Please enter a valid password",
    "editRepeatPwdTips" : "Please enter your password again",
    "pwdRepeatTips" : "Passwords do not match",
    "changePwdSucc" : "Your password has been changed",
    "bindEmail" : "Bind Email",
    "errorVrifyCodeTips" : "verification code error",
    "slectQuessionTips" : "Please select a security question?",
    "answerTips" : "Please enter the answer",
    "twoAnswerTips" : "Please select created security questions and enter the correct answers",
    "realNameValidateTips" : "Real name (4 to 60 characters)",
    "phoneValidateTips" : "Phone Number(6 to 18 digits)",
    "areaSelectTips" : "Please select region",
    "iDCardValidataTips" : "ID Number(1 to 60 digits)",
    "changeProfileSucc" : "Updated info saved",
    "editVrfCodeTips" : "Please enter verify code",
    "securityQuestionTips" : "Please create security questions to improve your account security. When you forget your password, you can answer the questions to reset the password.",
    "validateQuessionTips" : "Please select two different questions and verify. You can recreate the questions after the verification.",
    "originPwd" : "Original password",
    "newPwd" : "New password",
    "changePwdSuccess" : "Password changed. We suggest you login again right now to save your progress.",
    "accountName" : "Account name",
    "password" : "Please enter your password",
    "repeatPassword" : "Please repeat your password",
    "findPwdTips" : "Please enter the account that you want to retrieve the password from",
    "submit" : "Submit",
    "send" : "Send",
    "modify" : "modify",
    "haveAgree" : "Agree",
    "and" : "and",
    "privacyPolicy" : "Privacy Policy",
    "completeness" : "Completion",
    "gender" : "Gender",
    "male" : "male",
    "female" : "female",
    "birthday" : "Birthday",
    "phone" : "Phone",
    "region" : "Region",
    "ID" : "ID",
    "accountSetting" : "Account Settings",
    "upgrade" : "Upgrade",
    "profile" : "Profile",
    "changePassword" : "Change Password",
    "securityQuestion" : "Security Questions",
    "creatework_headerTitle" : "Create Ticket",
    "mylist_headerTitle" : "My Ticket",
    "bindEmailTips" : "Verify your e-mail for your account\'s security. If you forgot your password, we will send you an email to this e-mail address.",
    "enterEmailVrfcationTips" : "Please enter the verification code here.",
    "cancel" : "CANCEL",
    "bindTps" : "Bind your account to play the game on multiple devices!",
    "login" : "Log in",
    "logout" : "Log Out",
    "bind" : "Bind Account",
    "feedback" : "Feedback",
    "terms" : "Agreements",
    "tips" : "Notice",
    "guestSwitchTips" : "Guest account detected. After the login, your guest account data will be lost. Continue?",
    "register" : "SIGN UP",
    "realName" : "realName",
    "enterEmailTips" : "Please enter your email address",
    "emailVAlidateMsg" : "invalid email",
    "editEmaileTips" : "Please enter your email address",
    "checkServiceTips" : "Please read Terms of Use and Privacy Policy first.",
    "brithdayValidateTips" : "Enter your birthday",
    "facebookValidateTips" : "Facebook Account (1 to 60 characters)",
    "eritOriginPwdTips" : "Original password",
    "submitSuccess" : "submit success",
    "rebindEmail" : "Change Bound E-mail",
    "bindEmailSuccess" : "Email bound: \$email</br>Please use a bound e-mail to verify. You may reset your e-mail after verification.",
    "reSetSecurityQuessoon" : "You have successfully created the security questions </br></br>Please select different questions and verify. You can recreate the questions after the verification.",
    "canotModifyTips" : "Changes are NOT allowed upon submission, sure to submit?",
    "rebindEmailTips" : "Your e-mail is :\$email,please tap here to get verification code",
    "reGetVrfCode" : "Get Code",
    "findPwdWayTips" : "Please select one of the following ways",
    "emailWay" : "Retrieve by security email",
    "emailWayTips" : "You will receive a confirmation email and then you can reset the password",
    "quessionWay" : "Retrieve by security questions",
    "quessionWayTips" : "Answer the created security questions and then reset the password",
    "resetPwdBtn" : "Reset the password",
    "lastStep" : "Previous",
    "sendEmailTips" : "We have sent you an email to \$email.<br>Please enter the verification code you received here.",
    "setNewPwdTips" : "Congratulations!<br>User identity verified. Now you can reset your password.",
    "termsOfUse" : "Terms of Use",
    "creatework_create" : "Ticket",
    "creatework_createHolder" : "Select Type",
    "creatework_title" : "Subject",
    "creatework_titleHolder" : "Please enter a subject",
    "creatework_detail" : "Details",
    "creatework_detailHolder" : "Description must not contain more than 200 characters",
    "creatework_uploadTips" : "Please upload jpg/png files only. Uploaded file must be smaller than 5 MB.",
    "creatework_selectBox_selectTile" : "Type",
    "creatework_goGame" : "Return",
    "creatework_history" : "History",
    "mylist_noYet" : "No record",
    "mywork_solved" : "Problem solved?",
    "mywork_service" : "Rate us",
    "mywork_messageHolder" : "New message",
    "mywork_score" : "Score",
    "mywork_confirm" : "CONFIRM",
    "creatework_selectBox_selectList3" : "Other",
    "creatework_selectBox_selectList2" : "Account",
    "creatework_gameHolder" : "Select Game",
    "creatework_serverHolder" : "Select server",
    "contactService" : "Contact CS",
    "creatework_game" : "Game:",
    "creatework_server" : "Server:",
    "creatework_role" : "Character:",
    "selectRoleName" : "Select Character",
    "creatework_noRole" : "No character",
    "creatework_noGame" : "Game list is empty",
    "creatework_noServer" : "Server list is empty",
    "termText" : "I agree to 37GAMES",
    "backLogin" : "DECLINE",
    "creatework_roleHolder" : "Access after choosing your character",
    "findPwdFailTips" : "You have not set security questions. Please contact customer service.",
    "payMall" : "Mall",
    "selectPayment" : "Amount",
    "plzSelectPayWay" : "Select channel",
    "gainPlus" : "Add",
    "gainMorePlus" : "Add More",
    "gainMostPlus" : "Max",
    "plzSelectPayType" : "Select Payment Method",
    "roleName" : "Character",
    "payWay" : "Payment Channel",
    "plzSelectOtherWay" : "Alternative Payment Channel",
    "payment" : "Amount",
    "compensateTips" : "Surplus will be returned to you in \$gameCode",
    "extaGain" : "Bonus",
    "gameGold" : "In-game Currency",
    "compensate" : "Compensation",
    "payWayPlus" : "Channel Bonus",
    "neddPay" : "Payment",
    "submitOrder" : "Submit",
    "screenshotTips" : "Notice: take a screenshot of your order in case of a transaction error.",
    "storeFail" : "Failed to recharge",
    "storeFailTips" : "Transaction failed. Please submit order again or contact our customer service.",
    "storeAcceptance" : "Processing",
    "storeSuccessTips" : "Transaction shall be done in 15 mins.",
    "orderNumber" : "Order No.",
    "buyProduct" : "Recharge Item",
    "transactionAmount" : "Amount",
    "failReason" : "Reason",
    "payOntherORder" : "New Order",
    "reStore" : "Recharge Again",
    "confirm" : "Confirm",
    "switch" : "Switch Account",
    "completeTips" : "Please fill in your personal information. <mark class=\"yellowMarkColor\">Information will not be editable again</mark>. When you are trying to retrieve a lost account, you will be asked to provide correct personal information.",
    "creatework_selectBox_selectList0" : "Game Error",
    "creatework_selectBox_selectList1" : "Payment Error",
    "creatework_selectBox_selectList4" : "Translation Error",
    "mywork_solvedText" : "Problem solved",
    "browserPayErrBtnText" : "Payment Error",
    "browserPaySucBtnText" : "Payment completed",
    "browserPayingTips" : "Redirecting to third-party platform.<br/>Can close this page after payment.",
    "price_list_empty" : "No applicable sum",
    "pointCardTips" : "Note: This item only supports \$paymentAmount card",
    "forgetPwd" : "Forgot your password?",
    "payCenter" : "Recharge Center",
    "willGet" : "You will get",
    "goods" : "Item",
    "discount" : "Bonus",
    "payDiscount" : "Compensation",
    "payDiscountTips" : "Extra points will be converted to Diamonds",
    "hasQuestionPlease" : "If you have any questions, please",
    "pwdValidateMsg" : "Password must contain 6 to 20 characters",
    "payWayPlusC" : "Channel Bonus",
    "fwtk" : "TERMS OF SERVICE",
    "yszc" : "PRIVACY POLICY",
    "exchange" : "Échange de code cadeau",
    "remember" : "Remember my choice",
    "thirdInfo" : "About Account",
    "thirdInfoContent" : "Please bind your account in the in-game User Center. After that, log in the game using the bound account.",
    "unLink" : "This method is currently not supported",
    "favour" : "Bookmark",
    "goStoreTip" : "Please proceed to the payment page",
    "go" : "Go",
    "otherLogin" : "Other login methods",
    "qrCodeTip" : "Scan the QR code to get started!",
    "favourTip" : "Bookmark the page to play again later!",
    "share" : "Share",
    "landscapeTip" : "Please proceed in portrait mode",
    "leaveTip" : "Exit the game?",
    "selectRole" : "Please choose character",
    "selectMoney" : "Sélectionnez l\&#039;élément souhaité",
    "seletGameInfoFirst" : "Please choose game",
    "lowerIE" : "",
    "linkTermText" : "",
    "download" : "",
    "favourAndDownloadTip" : "",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "-" : "-"
}